import api from "./api";
const endpoint = "WebsiteRestController";
export const userServices = {
  async getMyProfile() {
    try {
      const result = await api.get(endpoint + "/user_profile");
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async changePassword(password_data) {
    try {
      const result = await api.post(
        endpoint + "/update_user_password",
        password_data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async updateUser(user_data) {
    try {
      const result = await api.post(endpoint + "/update_user", user_data);
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async getMyAssociation() {
    try {
      const result = await api.get(endpoint + "/get_my_association");
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
